'use client'
export { InputAccessoryView } from 'react-native'
